module.exports = __webpack_public_path__ + "img/envelopes.51c12cc1.png";